// import { WrappedPolicyDetailPage } from './lib/PolicyDetail';
// import { WrappedPolicyDetailPage } from './lib/PolicyDetail2';
import { WrappedPolicyDetailPage } from './lib/PolicyDetail3';

export * from './lib/components';
export default WrappedPolicyDetailPage;
